import React from 'react';
import { RouteProps } from 'react-router-dom';

const JoinMembership = React.lazy(() => import('../components/JoinMembership'));
const MembershipDashboardComponent = React.lazy(
  () => import('../components/MembershipDashboard'),
);
const PaymentSuccess = React.lazy(
  () => import('../components/PaymentStatus/Success'),
);
const PaymentFailure = React.lazy(
  () => import('../components/PaymentStatus/Failure'),
);

const Routes: RouteProps[] = [
  {
    path: '/restaurant/:restaurantRefId/membership/join',
    Component: JoinMembership,
  },
  {
    path: '/restaurant/:restaurantRefId/customer/:customerId/subscription/:subscriptionId/dashboard',
    Component: MembershipDashboardComponent,
  },
  {
    path: '/restaurant/:restaurantRefId/customer/:customerId/subscription/:subscriptionId/success',
    Component: PaymentSuccess,
  },
  {
    path: '/restaurant/:restaurantRefId/customer/:customerId/subscription/:subscriptionId/failure',
    Component: PaymentFailure,
  },
];

export default Routes;
